import authInstance from 'config/axios.config';

export const supportTicketServices = {
  getSupportTickets: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== 'all' && value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/ticket?${params}`);
    return res.data;
  },

  getTicketById: async (ticketId) => {
    const res = await authInstance.get(`/ticket/${ticketId}`);
    return res.data;
  },

  updateTicket: async ({ ticketId, data }) => {
    const res = await authInstance.patch(`/ticket/${ticketId}`, data);
    return res.data;
  },

  deleteTicket: async (ticketId) => {
    const res = await authInstance.delete(`/ticket/${ticketId}`);
    return res.data;
  },

  exportTickets: async ({
  status,
  category,
  priority,
  isEscalated,
  search,
  sortBy,
  sortOrder,
}) => {
  const params =
    new URLSearchParams({
      status:
        status === 'all'
          ? ''
          : status || '',

      category:
        category === 'all'
          ? ''
          : category || '',

      priority:
        priority === 'all'
          ? ''
          : priority || '',

      isEscalated:
        isEscalated === 'all'
          ? ''
          : isEscalated || '',

      search:
        search || '',

      sortBy:
        sortBy || 'createdAt',

      sortOrder:
        sortOrder || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/ticket/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
